import {
  SAVE_FILE_DISCOUNTS_ERROR,
  SAVE_FILE_DISCOUNTS_SUCCESS,
  SAVE_FILE_DISCOUNTS,
  GET_CLIENT_DISCOUNTS,
  GET_CLIENT_DISCOUNTS_SUCCESS,
  GET_CLIENT_DISCOUNTS_ERROR,
  CLEAR_CLIENT_DISCOUNTS,
  SEARCH_DISCOUNT_ITEMS,
  SEARCH_DISCOUNT_ITEMS_SUCCESS,
  SEARCH_DISCOUNT_ITEMS_ERROR,
  SUBMIT_DISCOUNT_REQUEST,
  SUBMIT_DISCOUNT_REQUEST_SUCCESS,
  SUBMIT_DISCOUNT_REQUEST_ERROR,
  RESET_SUBMIT_DISCOUNT_SUCCESS,
  GET_AVAILABLE_TARGETS,
  GET_AVAILABLE_TARGETS_SUCCESS,
  GET_AVAILABLE_TARGETS_ERROR,
} from '../constants/ActionsTypes'

export const saveDiscounts = (file) => {
  return {
    type: SAVE_FILE_DISCOUNTS,
    payload: file,
  }
}

export const saveDiscountsSuccess = () => {
  return {
    type: SAVE_FILE_DISCOUNTS_SUCCESS,
  }
}

export const saveDiscountsError = () => {
  return {
    type: SAVE_FILE_DISCOUNTS_ERROR,
  }
}

export const getClientDiscounts = (clientCode, filters = {}) => {
  return {
    type: GET_CLIENT_DISCOUNTS,
    payload: { clientCode, filters },
  }
}

export const getClientDiscountsSuccess = (discounts) => {
  return {
    type: GET_CLIENT_DISCOUNTS_SUCCESS,
    payload: discounts,
  }
}

export const getClientDiscountsError = (error) => {
  return {
    type: GET_CLIENT_DISCOUNTS_ERROR,
    payload: error,
  }
}

export const clearClientDiscounts = () => {
  return {
    type: CLEAR_CLIENT_DISCOUNTS,
  }
}

export const searchDiscountItems = (query, type, clientCode) => {
  return {
    type: SEARCH_DISCOUNT_ITEMS,
    payload: { query, type, clientCode },
  }
}

export const searchDiscountItemsSuccess = (items) => {
  return {
    type: SEARCH_DISCOUNT_ITEMS_SUCCESS,
    payload: items,
  }
}

export const searchDiscountItemsError = (error) => {
  return {
    type: SEARCH_DISCOUNT_ITEMS_ERROR,
    payload: error,
  }
}

export const submitDiscountRequest = (request) => {
  return {
    type: SUBMIT_DISCOUNT_REQUEST,
    payload: request,
  }
}

export const submitDiscountRequestSuccess = (response) => {
  return {
    type: SUBMIT_DISCOUNT_REQUEST_SUCCESS,
    payload: response,
  }
}

export const submitDiscountRequestError = (error) => {
  return {
    type: SUBMIT_DISCOUNT_REQUEST_ERROR,
    payload: error,
  }
}

export const getAvailableTargets = (clientCode, type) => {
  return {
    type: GET_AVAILABLE_TARGETS,
    payload: { clientCode, type },
  }
}

export const getAvailableTargetsSuccess = (targets) => {
  return {
    type: GET_AVAILABLE_TARGETS_SUCCESS,
    payload: targets,
  }
}

export const getAvailableTargetsError = (error) => {
  return {
    type: GET_AVAILABLE_TARGETS_ERROR,
    payload: error,
  }
}

export const resetSubmitDiscountSuccess = () => {
  return {
    type: RESET_SUBMIT_DISCOUNT_SUCCESS,
  }
}
